import React from "react";
import { t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";
import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { strings } from "../../../localization";
import { getDefaultFinancingPlan } from "../../../utils/financing";
import { formatAPR } from "../../../utils/format";

import styles from "./index.module.scss";

export const FinancingPreQualHero = () => {
    const defaultPlan = getDefaultFinancingPlan();
    const cardName = strings.get("FINANCING_CARD_NAME") || "";
    return (
        <section className={styles.root}>
            <div className={styles.wrapper}>
                {defaultPlan && (
                    <h2 className={styles.heading}>
                        {richT(
                            interpolate(
                                t`%(apr)s APR for %(length)s Months<sup>1</sup>`,
                                {
                                    apr: formatAPR(defaultPlan.apr),
                                    length: `${defaultPlan.length}`,
                                },
                            ),
                        )}
                    </h2>
                )}
                <p className={styles.copy}>
                    {richT(t`Check if you pre-qualify for a ${cardName}`)}
                </p>
                <ul className={styles.list}>
                    <li className={styles.item}>
                        <span className={styles.icon} aria-hidden="true" />
                        {t`Instant Decision`}
                    </li>
                    <li className={styles.item}>
                        <span className={styles.icon} aria-hidden="true" />
                        {t`No Impact to your Credit Score`}
                    </li>
                </ul>
            </div>
        </section>
    );
};
